// import core component
import Image from "next/image";

// import styles
import styles from "./customimage.module.scss";

// interface
import CustomImageProps from "@/interfaces/CustomImage";

// import arrow
import ArrowLeft from "public/images/svgs/arrow-curved-down-left.svg";
import ArrowRight from "public/images/svgs/arrow-curved-down-right.svg";

// import utils
import {
  handleBadgesStyle,
  handleRoundedImageSize,
  handleImageStyleFormat,
} from "@/utils/CustomImage";
import handleClassName from "@/utils/handleClassName";

export default function CustomImage({
  image: {
    src,
    alt,
    size,
    asBadges,
    isRound,
    isVisibleOnMobile,
    roundImageFormat,
    isArrowBesideImage,
  },
  isAllEgal,
  badgesStyle,
  imageId,
  imageClassName,
  imageRef,
  arrowClass,
  isHero,
}: CustomImageProps) {
  if (isRound && roundImageFormat !== "none") {
    return (
      <div
        ref={imageRef}
        id={`${imageId}`}
        className={`${styles._default} ${
          styles._rounded
        } ${handleRoundedImageSize(roundImageFormat, styles)} ${
          isVisibleOnMobile ? "" : styles._hidden
        } ${imageClassName ? imageClassName : ""}`}
      >
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          <Image
            src={src}
            alt={alt}
            layout="fill"
            priority={isHero ? true : false}
            quality={90}
          />
        </div>
      </div>
    );
  }

  if (asBadges) {
    return (
      <div
        ref={imageRef}
        id={`${imageId}`}
        className={`${styles._default} ${handleImageStyleFormat(
          asBadges,
          isAllEgal,
          isRound,
          styles
        )} ${handleBadgesStyle(asBadges, badgesStyle, styles)} ${
          imageClassName ? imageClassName : ""
        }`}
      >
        <div>
          <Image
            src={src}
            alt={alt}
            width={size.width.max}
            height={size.height.max}
            layout={"responsive"}
            priority={false}
            quality={90}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      ref={imageRef}
      id={`${imageId}`}
      style={{
        width: `clamp(${size.width.min}px,${(size.width.max * 100) / 1440}vw,${
          size.width.max
        }px)`,
        maxHeight: `${size.height.max}px`,
        maxWidth: `${size.width.max}px`,
      }}
      className={`${styles._default} ${handleImageStyleFormat(
        asBadges,
        isAllEgal,
        isRound,
        styles
      )} ${imageClassName ? imageClassName : ""} ${
        isVisibleOnMobile ? "" : styles._hidden
      }`}
    >
      {isArrowBesideImage && (
        <div
          className={`${arrowClass} ${handleClassName(
            ["arrow", "arrow--left"],
            styles
          )}`}
        >
          <Image
            src={ArrowLeft}
            alt="left curved arrow"
            priority={false}
            quality={90}
          />
        </div>
      )}
      <Image
        src={src}
        alt={alt}
        width={size.width.max}
        height={size.height.max}
        layout="responsive"
        priority={false}
        quality={90}
      />
      {isArrowBesideImage && (
        <div
          className={`${arrowClass} ${handleClassName(
            ["arrow", "arrow--right"],
            styles
          )}`}
        >
          <Image
            src={ArrowRight}
            alt="right curved arrow"
            priority={false}
            quality={90}
          />
        </div>
      )}
    </div>
  );
}
